import { Skeleton, StatSkeleton, TableSkeleton } from '@/components/ui/Skeleton'

/** A page while its code or data loads (WP-08): the shape of a page — the header, three KPI
 *  tiles and table rows — not a word. Inside the shell (the rail is already there). */
export function PageSkeleton() {
  return (
    <div className="flex flex-col gap-6" role="status" aria-label="Загрузка">
      <Skeleton className="h-8 w-56 max-w-full" />
      <StatSkeleton count={3} className="xl:grid-cols-3" />
      <div className="rounded-md border border-hairline bg-surface-1">
        <TableSkeleton rows={6} cols={5} />
      </div>
    </div>
  )
}

/**
 * The whole admin before the session is known (WP-08): restoring it from the refresh cookie
 * takes a round trip, and a bare «Загрузка…» on an empty page used to flash before the shell.
 * Same frame as `Layout`: the 264 px rail from `lg`, the 56 px top bar below it, the page.
 */
export function ShellSkeleton() {
  return (
    <div
      className="min-h-dvh bg-void lg:grid lg:grid-cols-[theme(spacing.rail)_1fr]"
      role="status"
      aria-label="Загрузка"
    >
      <aside className="hidden border-r border-hairline bg-surface-1 p-4 lg:flex lg:flex-col lg:gap-3">
        <Skeleton className="mb-4 h-8 w-28" />
        {Array.from({ length: 12 }).map((_, i) => (
          <Skeleton key={i} className="h-5 w-40" />
        ))}
      </aside>
      <header className="flex h-14 items-center justify-between border-b border-hairline bg-surface-1 px-4 lg:hidden">
        <Skeleton className="h-7 w-24" />
        <Skeleton className="h-8 w-20" />
      </header>
      <main className="min-w-0">
        <div className="flex items-center justify-between gap-4 border-b border-hairline bg-surface-1 px-4 py-3 sm:px-6 lg:px-8">
          <Skeleton className="hidden h-5 w-32 lg:block" />
          <Skeleton className="h-10 w-full max-w-sm" />
        </div>
        <div className="p-4 sm:p-6 lg:p-8"><PageSkeleton /></div>
      </main>
    </div>
  )
}
